import React from 'react';

export interface PageContainerProps {
  children: React.ReactNode;
  className?: string;
}

export function PageContainer({ children, className = '' }: PageContainerProps) {
  return (
    <div className={`w-full space-y-6 ${className}`}>
      {children}
    </div>
  );
}

export default PageContainer;
